module.exports = __webpack_public_path__ + "slide1-welcomeoctopus-ie11.d7389ae84a80812016aeaecd658a3fb5.hashedasset.svg";